
import LazyLoad from "react-lazyload";
import { Link } from 'react-router-dom'
const Administration = () => {
    return (
        <>
            <div className="breadcrumb">
                <h2>School Administration</h2>
                <ul>
                    <li><Link to="/"> Home <i className="fas fa-angle-right"></i> </Link></li>
                    <li>|</li> 
                    <li>About</li>
                    <li>|</li>
                    <li>School Administration</li>
                </ul>
            </div>
            <div className="inner_page">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <h3 className="heading">School Administration</h3>
                        </div>
                        <div className="col-lg-7">
                            <p><span>St. Francis School, Amritsar</span> is a recognized Minority Educational Institution, enjoying all the rights and privileges guaranteed under Article 29 & 30 of the constitution of India. The School is locally administered by the guidance and direction of a Managing Director appointed by the Diocese of Jalandhar.</p>
                            <p>The Sisters of the Congregation of the Franciscan Sister of St. Mary of the angels run the school under the management of the Diocese of Jalandhar. The <span>Diocesan Board of education, Jalandhar</span> supervises the education policies of the institution.</p>
                            <p>The religious Sisters who are serving in the various Christian institutions in Punjab and elsewhere are people who are voluntarily vowed to God to lead a holy and dedicated life of selfless service to their fellow human beings. In order to surrender themselves totally to the love of Gog and service of humanity they renounce family life and live in religious communities known as convents, a home of prayer and serenity.</p>
                        </div>
                        <div className="col-lg-5">
                            <LazyLoad><img src="https://webapi.entab.info/api/image/SFSAP/public/Images/administration.jpg" alt="st francis school, Amritsar" className="img-fluid bordered_img" /></LazyLoad>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Administration
